export const leadsTheme = {
  tablist: {
    base: '',
    styles: {
      default: '',
    },

    tabitem: {
      base:
        `
        flex 
        items-center 
        justify-center 
        text-[#e44131] 
        hover:bg-[#b93527] 
        hover:text-white
        hover:border-0
        rounded-none
        shadow-l-md
        transition-shadow 
        duration-200
        gap-0

      `,
      styles: {
        default: {
          active: { on: 'text-white bg-[#e44131] hover:bg-[#b93527]', off: 'border-t-[#e44131] border-l-[#e44131]' }, // Ajuste para objeto com propriedades 'on' e 'off'
        },
      },
      icon: "mr-2 h-6 w-6"
    },
  },
  // tabpanel: 'p-4 bg-gray-50 dark:bg-gray-800',
};
